import React from 'react'

import { stringifyDate } from '../../modules'

import Modal from "../reusable/modal"

const SystemLog = ({ toggle, visible, log }) => {
    return (
        <Modal
            w={ 450 }
            title="System Log"
            toggle={toggle}
            visible={visible}>
            <p className='text-gray-500'>Recorded on { stringifyDate(log?.date) }</p>
            <h2 className="mt-2">Log Category</h2>
            <p className={ log.category.toLowerCase().includes('error') ? 'text-red-500' : 'text-gray-500' }>{ log?.category }</p>
            <hr />
            <h2 className="mt-2">Log Title</h2>
            <p>{ log?.title }</p>
            <hr />
            <h2 className="mt-2">Log Description</h2>
            <p>{ log?.desc }</p>
            {
                log?.stack?.length > 0 &&
                <>
                    <hr />
                    <h2 className="mt-2">Log Stack</h2>
                    {
                        log?.stack.map(stack =>
                            <p>{ stack }</p>
                        )
                    }
                </>
            }
        </Modal>
    )
}

export default SystemLog